import axiosInstance from './api';

export const triggerPasswordReset = (data) => axiosInstance.post('/authorize/reset-password', data)

export const conpletePasswordReset = ({ code, password }) => axiosInstance.put(`/authorize/reset-password/${code}`, {
  password
})